"use client"

import React, {createContext, useCallback, useMemo, useState} from 'react';
import {usePathname, useSearchParams} from "next/navigation";

interface BreadcrumbsContextType {
  breadcrumbs?: React.ReactNode;
  setBreadcrumbs: (bc: React.ReactNode) => void;
}

export const BreadcrumbsContext = createContext<BreadcrumbsContextType>({setBreadcrumbs: () => null});

export const BreadcrumbsProvider = ({children}: { children: React.ReactNode }) => {
  const [breadcrumbs, setBreadcrumbs] = useState<React.ReactNode>();
  const [fullPath, setFullPath] = useState<string | undefined>();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const curFullPath = useMemo(() => {
    const queryString = searchParams.toString();
    return queryString ? `${pathname}?${queryString}` : pathname;
  }, [pathname, searchParams])
  const updateBreadcrumbs = useCallback((bc: React.ReactNode) => {
    setBreadcrumbs(bc)
    setFullPath(curFullPath)
  }, [setBreadcrumbs, curFullPath]);
  return (
    <>
      <BreadcrumbsContext.Provider value={{
        breadcrumbs: curFullPath === fullPath && breadcrumbs,
        setBreadcrumbs: updateBreadcrumbs,
      }}>
        {children}
      </BreadcrumbsContext.Provider>
    </>
  );
};
